export default {
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    toggleLoading() {
      this.loading = !this.loading;
    },
    enableLoading() {
      this.loading = true;
    },
    disableLoading() {
      this.loading = false;
    },
    isLoading() {
      return this.loading === true;
    }
  },
};
